<template>
  <div class="breadcrumb-container" v-if="breadcrumbs.length > 1">
    <div class="container">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb" itemscope itemtype="https://schema.org/BreadcrumbList">
          <li 
            v-for="(item, index) in breadcrumbs" 
            :key="index"
            class="breadcrumb-item"
            :class="{ active: index === breadcrumbs.length - 1 }"
            itemprop="itemListElement" 
            itemscope 
            itemtype="https://schema.org/ListItem"
          >
            <router-link 
              v-if="index < breadcrumbs.length - 1" 
              :to="item.path"
              itemprop="item"
            >
              <span itemprop="name">{{ item.name }}</span>
            </router-link>
            <span v-else itemprop="name">{{ item.name }}</span>
            <meta itemprop="position" :content="index + 1" />
          </li>
        </ol>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Breadcrumb',
  computed: {
    breadcrumbs() {
      const route = this.$route;
      const breadcrumbs = [
        { name: '首頁', path: '/' }
      ];

      // 根据路由路径生成面包屑
      const routeMap = {
        '/service': { name: '相關服務', path: '/service' },
        '/servicedetail': { name: '服務詳情', path: '/servicedetail' },
        '/newsinformation': { name: '新聞動態', path: '/newsinformation' },
        '/newsdetail': { name: '新聞詳情', path: '/newsdetail' },
        '/companyintroduction': { name: '公司介紹', path: '/companyintroduction' },
        '/jobchance': { name: '人才资源', path: '/jobchance' },
        '/contactus': { name: '聯繫我們', path: '/contactus' }
      };

      if (route.path.startsWith('/project/detail')) {
        breadcrumbs.push({ name: '項目詳情', path: route.path });
      } else if (routeMap[route.path]) {
        breadcrumbs.push(routeMap[route.path]);
      }

      return breadcrumbs;
    }
  }
}
</script>

<style scoped>
.breadcrumb-container {
  background-color: #f8f9fa;
  padding: 10px 0;
  border-bottom: 1px solid #e9ecef;
}

.breadcrumb {
  background: transparent;
  padding: 0;
  margin: 0;
  font-size: 14px;
}

.breadcrumb-item {
  color: #6c757d;
}

.breadcrumb-item a {
  color: #1e73be;
  text-decoration: none;
  transition: color 0.3s ease;
}

.breadcrumb-item a:hover {
  color: #1860a3;
  text-decoration: underline;
}

.breadcrumb-item.active {
  color: #495057;
  font-weight: 500;
}

.breadcrumb-item + .breadcrumb-item::before {
  content: ">";
  color: #6c757d;
  margin: 0 8px;
}

@media (max-width: 768px) {
  .breadcrumb {
    font-size: 12px;
  }
  
  .breadcrumb-item + .breadcrumb-item::before {
    margin: 0 4px;
  }
}
</style> 


// WEBPACK FOOTER //
// src/components/Breadcrumb.vue